<template>
  <b-form-group :label="properties.label">
    <div class="d-flex mb-2" v-if="properties.allowCollections && selectedView">
      <b-form-radio
        v-model="selectedViewWrapper"
        name="multiple-text-selected-view"
        value="custom"
        >Custom</b-form-radio
      >
      <b-form-radio
        v-model="selectedViewWrapper"
        name="multiple-text-selected-view"
        value="collection"
        class="ml-4"
        >Collection</b-form-radio
      >
    </div>
    <div
      v-if="selectedView == 'custom'"
      class="border rounded border-color-light-gray"
    >
      <div class="bg-light-gray py-2 px-3">
        <b-input-group class="d-flex">
          <template v-slot:append>
            <b-button
              size="sm"
              variant="primary"
              class="text-white"
              style
              @click="addText"
              >Add</b-button
            >
          </template>
          <b-input
            v-model="form.text"
            size="sm"
            :errors="formErrors.text"
          ></b-input>
        </b-input-group>
      </div>
      <div class="texts-list-container">
        <b-list-group v-if="value.length > 0" class="mt-1 p-1 forms-list">
          <draggable v-model="propertyValue">
            <b-list-group-item
              class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
              v-for="(text, textIndex) in value"
              :key="textIndex"
            >
              <div>
                <b-icon-grip-horizontal></b-icon-grip-horizontal>
                {{ text }}
              </div>
              <img
                class="filter-value-delete"
                :src="require('../../../assets/icons/close-circle.png')"
                @click="removeText(textIndex)"
              />
            </b-list-group-item>
          </draggable>
        </b-list-group>
        <div v-else class="text-center color-custom-dark-grey m-1">
          No items selected.
        </div>
      </div>
    </div>
    <div v-if="selectedView == 'collection'">
      <b-select
        size="sm"
        v-model="propertyValueCollection"
        :options="collections"
      />
    </div>
  </b-form-group>
</template>

<script>
import Draggable from "vuedraggable";
import collectionServer from "../../../server/collection";

export default {
  name: "MultipleTextPropertyType",
  components: { Draggable },
  props: ["properties", "property", "value"],
  data() {
    return {
      selectedView: "",
      form: {
        text: ""
      },
      formErrors: {
        text: []
      },
      collections: []
    };
  },
  async mounted() {
    if (this.properties.allowCollections) {
      await this.getCollection();
      if (typeof this.value == "string") this.selectedView = "collection";
      else this.selectedView = "custom";
    } else this.selectedView = "custom";
  },
  methods: {
    async getCollection() {
      const collections = await collectionServer.query();
      this.collections = collections.map(c => ({
        value: `{{collections.${c.name}}}`,
        text: c.name
      }));
    },
    addText() {
      if (this.form.text.trim()) {
        const newTexts = [...this.value];
        newTexts.push(this.form.text);
        this.$emit("update-value", this.property, newTexts);
        this.form.text = "";
      }
    },
    removeText(itemIndex) {
      const newValue = [...this.value];
      newValue.splice(itemIndex, 1);
      this.$emit("update-value", this.property, newValue);
    },
    changeType(newType) {
      if (newType == "custom") this.$emit("update-value", this.property, []);
      if (newType == "collection") {
        this.$emit("update-value", this.property, "");
      }
    }
  },
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    },
    propertyValueCollection: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (newValue.length > 0)
          this.$emit("update-value", this.property, newValue, false);
      }
    },
    selectedViewWrapper: {
      get() {
        return this.selectedView;
      },
      set(newValue) {
        this.changeType(newValue);
        this.selectedView = newValue;
      }
    }
  }
};
</script>

<style scoped>
.texts-list-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  min-width: 50px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
</style>
